/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import {
  IconDownload,
  IconEye,
  IconMapPin,
  IconPlus,
  IconSearch,
  IconX,
  IconUpload,
} from "@tabler/icons-react";
import ToggleButton from "../../../components/ToggleButton";
import CopyButton from "../../../components/CopyButton";
import GridView from "../../../components/common/GridView";
import AddMerchantModal from "./AddMerchantModal";
import { useForm } from "react-hook-form";
import { T, useLanguage } from "../../../context/LanguageContext";
import {
  useMerchantCreateMutation,
  useMerchantDeleteMutation,
  useMerchantListData,
  useMerchantStatusMutation,
} from "../../../apis/merchantApis";
import toast from "react-hot-toast";
import Pagination from "../../../components/common/Pagination";
import useDebounce from "../../../utilities/useDebounce";
import { maskedSecretKey } from "../../../utilities/helper";
import formatDate from "../../../utilities/helper";
import MessageModal from "../../../components/MessageModal";
import { useNavigate } from "react-router-dom";
import NewCommonModal from "../../../components/common/NewCommonModal";
import NoDataFound from "../../../components/common/NoDataFound";
import MerchantBulkUploadModals from "./MerchantBulkUploadModals";
import MerchantBulkResponseModals from "./MerchantBulkResponseModals";
import { useSelector } from "react-redux";
import EntriesSelector from "../../../components/common/EntriesSelector";
import { handleDownload } from "../../../utilities/downloadHelper";
import { usePermission } from "../../../hooks/usePermissionTabs";
import ViewMerchantModal from "./ViewMerchantModal";

type merchantData = {
  id?: string;
  name: string;
  mobileNo: string;
  email: string;
  contactType: string;
  vatNumber: string;
  nationalId: string;
  nationalCopy: string;
  crNumber: string;
  warehouse: string;
  contactPerson: string;
  district: string;
  city: string;
  paymentTerm: string;
  access: string;
  clientType: string;
  location: string;
  status?: string;
};

export default function MerchantManagement({
  setHeaderActions,
  setHeaderButtons,
}: {
  setHeaderActions?: (node: React.ReactNode) => void;
  setHeaderButtons?: (node: React.ReactNode) => void;
}) {
  const { t } = useLanguage();
  const [viewMode, setViewMode] = useState<string>(
    () => localStorage.getItem("ClientModeActiveRole") || "list",
  );
  const [showSearch, setShowSearch] = useState(false);

  // const [viewMerchantModal, setViewMerchantModal] = useState(false);
  // const [selectedMerchantId, setSelectedMerchantId] = useState<string | null>(
  //   null,
  // );

  useEffect(() => {
    localStorage.setItem("ClientModeActiveRole", viewMode);
  }, [viewMode]);

  // const [credential, setCredential] = useState<boolean>(false);
  const [clickedMerchantData, setClickedMerchantData] = useState<
    any | undefined
  >();
  const [activeDeleteModal, setActiveDeleteModal] = useState<boolean>(false);
  // const [openResponse, SetOpenResponse] = useState<boolean | string>(false);
  // const [staffBulkResponse, setStaffBulkResponse] = useState<any>(null);

  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [allSelectedData, setAllSelectedData] = useState<merchantData[]>([]);
  const [showCheckboxes, setShowCheckboxes] = useState<boolean>(false);

  // const credentialToggleModal = () => {
  //   setCredential(!credential);
  //   if (!credential) {
  //     reset();
  //   }
  // };

  const { allowed: canCreateClient, isLoading } = usePermission(
    "clients",
    "create",
  );
  const { allowed: canUpdateClient } = usePermission("clients", "update");
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm<any>();
  // const [isOpen, setIsOpen] = useState(false);
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [id, setId] = useState<string>("");
  const [status, setStatus] = useState<string>("");

  const { mutate, isPending } = useMerchantCreateMutation();
  const { mutate: statusMutate, isPending: isStatusPending } =
    useMerchantStatusMutation(id);
  const { mutate: deleteMutate, isPending: isDeletePending } =
    useMerchantDeleteMutation(id);
  const debouncedSearchFor = useDebounce(searchFor, 550);

  const {
    isPending: listPending,
    isFetching,
    refetch,
  } = useMerchantListData(pageNo, limit, debouncedSearchFor);

  const data = useSelector((state: any) => state?.client?.data);

  // Calculate merchant statistics dynamically
  const merchantStats = {
    total: data?.total || 0,
    active:
      data?.clients?.filter((c: any) => c?.status === "ACTIVE").length || 0,
    inactive:
      data?.clients?.filter((c: any) => c?.status === "INACTIVE").length || 0,
  };

  useEffect(() => {
    if (id && status) {
      statusMutate(
        { status: status === "ACTIVE" ? "INACTIVE" : "ACTIVE" },
        {
          onSuccess: (data) => {
            refetch();
            setId("");
            setStatus("");
          },
          onError: (error) => {
            console.log(error, "error");
            toast.error(`${error}`);
            setId("");
            setStatus("");
          },
        },
      );
    }
  }, [id, status]);

  const deleteClient = () => {
    deleteMutate(undefined, {
      onSuccess: (data) => {
        setActiveDeleteModal(false);
        refetch();
        toast.success("Merchant deleted successfully");
      },
      onError: (error: any) => {
        console.error(error, "error");
        toast.error(error.message || "Failed to delete Merchant");
      },
    });
  };



  // const handleCreate = (data: any) => {
  //   mutate(
  //     { ...data, ...allIds },
  //     {
  //       onSuccess: (data) => {
  //         credentialToggleModal();
  //         reset();
  //         refetch();
  //         toast.success("Merchant Add  successfully!");
  //       },
  //       onError: (error) => {
  //         console.log(error, "error");
  //         const errorMessage =
  //           error?.response?.data?.error?.message ||
  //           error?.response?.data?.message ||
  //           error?.message ||
  //           (typeof error === "string" ? error : null) ||
  //           "Something went wrong";

  //         toast.error(errorMessage);
  //       },
  //     },
  //   );
  // };

  useEffect(() => {
    if (data?.clients) {
      setAllSelectedData((prev) => {
        const filteredPrev = prev.filter((item: any) =>
          selectedRows.includes(item.id),
        );
        const newSelected = data.clients.filter(
          (s: any) =>
            selectedRows.includes(s.id) &&
            !filteredPrev.some((item) => item.id === s.id),
        );
        return [...filteredPrev, ...newSelected];
      });
    }
  }, [data?.clients, selectedRows]);

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  useEffect(() => {
    refetch();
  }, [debouncedSearchFor, pageNo, limit]);

  useEffect(() => {
    refetch();
  }, []);

  const [open, setOpen] = useState<boolean | string>(false);
  // const [openbluk, SetOpenBluk] = useState<boolean | string>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [columnsData, setColumnsData] = useState([
    { text: "Checkbox", value: "checkbox", isShow: showCheckboxes },
    { text: "S/N", value: "sn", isShow: true },
    { text: "Name", value: "name", isShow: true },
    { text: "Merchant ID", value: "clientId", isShow: true },
    { text: "Secret Key", value: "secretKey", isShow: true },
    { text: "Email", value: "email", isShow: true },
    { text: "Warehouse City", value: "location", isShow: true },
    { text: "Office City", value: "merchantCity", isShow: true },
    { text: "Office District", value: "merchantDistrict", isShow: true },
    { text: "Office Short Addr", value: "merchantShortAddress", isShow: true },
    { text: "Contact", value: "contact", isShow: true },
    { text: "Date", value: "createdAt", isShow: true },
    { text: "Status", value: "status", isShow: true },
    { text: "Actions", value: "actions", isShow: true },
  ]);

  const setHeadings = (value: string | undefined, checked: boolean) => {
    setColumnsData((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col,
      ),
    );
  };


  // Render stats capsule in the top-right page header
  useEffect(() => {
    if (!setHeaderButtons) return;

    setHeaderButtons(
      <div className="flex items-center gap-2 bg-white/70 backdrop-blur-sm px-4 py-1.5 rounded-xl border border-slate-200 shadow-sm text-[11px] select-none font-bold min-h-8">
        <div className="flex items-center gap-1.5">
          <span className="text-slate-500"><T>Total</T>:</span>
          <span className="text-blue-700 bg-blue-50 border border-blue-100 px-1.5 py-0.5 rounded">{merchantStats.total}</span>
        </div>
        <span className="h-3 w-px bg-slate-300" />
        <div className="flex items-center gap-1.5">
          <span className="text-slate-500"><T>Active</T>:</span>
          <span className="text-emerald-700 bg-emerald-50 border border-emerald-100 px-1.5 py-0.5 rounded">{merchantStats.active}</span>
        </div>
        <span className="h-3 w-px bg-slate-300" />
        <div className="flex items-center gap-1.5">
          <span className="text-slate-500"><T>Inactive</T>:</span>
          <span className="text-rose-700 bg-rose-50 border border-rose-100 px-1.5 py-0.5 rounded">{merchantStats.inactive}</span>
        </div>
      </div>
    );

    return () => {
      setHeaderButtons(null);
    };
  }, [setHeaderButtons, merchantStats.total, merchantStats.active, merchantStats.inactive]);

  const handleSelectRow = (id: string) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    if (selectedRows.length === data?.clients?.length) {
      setSelectedRows((prev) =>
        prev.filter((id) => !data.clients.some((s: any) => s.id === id)),
      );
    } else {
      const newSelections =
        data?.clients
          ?.filter((s: any) => !selectedRows.includes(s.id))
          .map((s: any) => s.id) || [];
      setSelectedRows((prev) => [...prev, ...newSelections]);
    }
  };

  // const columns = columnsData
  //   .filter((c) => c.isShow)
  //   .map((col) => {
  //     switch (col.value) {
  //       case "checkbox":
  //         return {
  //           label: (
  //             <label className="relative flex items-center cursor-pointer">
  //               <input
  //                 type="checkbox"
  //                 checked={
  //                   data?.clients?.length > 0 &&
  //                   data?.clients?.every((s: any) =>
  //                     selectedRows.includes(s.id),
  //                   )
  //                 }
  //                 onChange={handleSelectAll}
  //                 className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037]
  //                               bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
  //               />
  //               <span
  //                 className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
  //                               top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
  //               >
  //                 ✓
  //               </span>
  //             </label>
  //           ),
  //           render: (s: any) => (
  //             <label className="relative flex items-center cursor-pointer">
  //               <input
  //                 type="checkbox"
  //                 checked={selectedRows.includes(s.id)}
  //                 onChange={() => handleSelectRow(s.id)}
  //                 className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037]
  //                 bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
  //               />
  //               <span
  //                 className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
  //                               top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
  //               >
  //                 ✓
  //               </span>
  //             </label>
  //           ),
  //         };
  //       case "sn":
  //         return {
  //           label: "#",
  //           render: (_: any, i: number) => (pageNo - 1) * limit + (i + 1),
  //         };
  //       case "name":
  //         return {
  //           label: "Name",
  //           render: (c: any) => (
  //             <div className="flex items-center gap-3 max-w-xs">
  //               <img
  //                 src={c?.companyLogo || "img/dummy-logo.png"}
  //                 className="w-10 h-10 rounded object-cover"
  //                 alt={c.name}
  //               />
  //               <span className="truncate">{c.name}</span>
  //             </div>
  //           ),
  //         };
  //       case "clientId":
  //         return { label: "Merchant ID", render: (c: any) => c?.clientId };
  //       case "secretKey":
  //         return {
  //           label: "Secret Key",
  //           render: (c: any) => (
  //             <div className="flex items-center justify-between gap-2 w-36 bg-white py-0.5 px-2 border border-[#D2D2D2] rounded">
  //               <span className="truncate">
  //                 {maskedSecretKey(c?.secretKey)}
  //               </span>
  //               <CopyButton text={c?.secretKey} />
  //             </div>
  //           ),
  //         };
  //       case "email":
  //         return { label: "Email", render: (c: any) => c?.email };
  //       case "location":
  //         return { label: "Warehouse City", render: (c: any) => c?.city };
  //       case "merchantCity":
  //         return {
  //           label: "Office City",
  //           render: (c: any) => c?.merchantCityName || c?.merchantCityId,
  //         };
  //       case "merchantDistrict":
  //         return {
  //           label: "Office District",
  //           render: (c: any) =>
  //             c?.merchantDistrictName || c?.merchantDistrictId,
  //         };
  //       case "merchantShortAddress":
  //         return {
  //           label: "Office Short Addr",
  //           render: (c: any) => c?.merchantShortAddress || "-",
  //         };
  //       case "contact":
  //         return { label: "Contact", render: (c: any) => c?.mobileNo };
  //       case "createdAt":
  //         return {
  //           label: "Date",
  //           render: (c: any) => formatDate(c.created_at || c.createdAt),
  //         };
  //       case "status":
  //         return {
  //           label: "Status",
  //           render: (c: any) => (
  //             <div className="flex items-center justify-center">
  //               <ToggleButton
  //                 onChange={() => {
  //                   setId(c?.id);
  //                   setStatus(c?.status);
  //                   setActiveModal(true);
  //                 }}
  //                 checked={c?.status === "ACTIVE"}
  //               />
  //             </div>
  //           ),
  //         };
  //       case "actions":
  //         return {
  //           label: "Actions",
  //           render: (c: any) => (
  //             <div className="relative text-center">
  //               <button
  //                 onClick={() => {
  //                   setSelectedMerchantId(c.id);
  //                   setViewMerchantModal(true);
  //                 }}
  //                 className="p-2 border rounded-full bg-[#F7F6F2]"
  //               >
  //                 <IconEye size={22} />
  //               </button>
  //             </div>
  //           ),
  //         };
  //       default:
  //         return { label: "", render: () => null };
  //     }
  //   });

  const mapDataToExport = (c: any, index: number) => ({
    "S/N": index + 1,
    Name: c.name || c.name,
    "Merchant Id": c.clientId,
    "Secret Key": c.secretKey,
    Email: c.email,
    "Warehouse City": c.city,
    "Office City": c.merchantCityName || c.merchantCityId,
    "Office District": c.merchantDistrictName || c.merchantDistrictId,
    "Office Short Addr": c.merchantShortAddress,
    Contact: c.mobileNo,
    Date: formatDate(c.created_at),
    Status: c.status,
  });

  return (
    <>
     <div className="">
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
          {/* Left side: Brand badge */}
          <div className="flex flex-wrap items-center gap-3">
           
          </div>

          {/* Right side: Search + Export + Entries + Stats capsule */}
          <div className="flex items-center flex-wrap gap-2.5">
            {/* Sliding Search */}
            <div className="relative flex items-center">
              <div
                onClick={() => {
                  if (!showSearch) {
                    setShowSearch(true);
                  }
                }}
                className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-md bg-white shadow-sm h-8 ${showSearch ? "w-64 px-2 cursor-default" : "w-8 justify-center cursor-pointer"
                  }`}
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowSearch(!showSearch);
                  }}
                  className="flex items-center justify-center text-slate-700 focus:outline-none flex-shrink-0"
                  title="Search"
                >
                  <IconSearch size={17} stroke={2.5} />
                </button>
                {showSearch && (
                  <>
                    <input
                      type="text"
                      value={searchFor}
                      onChange={(e) => {
                        setSearchFor(e.target.value);
                        setPageNo(1);
                      }}
                      placeholder={t("Search...")}
                      autoFocus
                      className="flex-1 ml-2 bg-transparent text-xs text-slate-800 placeholder-slate-400 outline-none border-none focus:outline-none focus:ring-0"
                    />
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setSearchFor("");
                        setShowSearch(false);
                        setPageNo(1);
                      }}
                      className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 focus:outline-none flex-shrink-0"
                      title="Clear & Close"
                    >
                      <IconX size={14} stroke={2.5} />
                    </button>
                  </>
                )}
              </div>
            </div>

            {/* Export to Excel */}
            <button
              onClick={() =>
                handleDownload({
                  selectedRows,
                  allSelectedData,
                  setSelectedRows,
                  setAllSelectedData,
                  showCheckboxes,
                  setShowCheckboxes,
                  setColumnsData,
                  mapDataToExport,
                  fileName: "client_management.xlsx",
                })
              }
              className={`flex items-center justify-center h-8 bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-md transition shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 duration-150 ${showCheckboxes && selectedRows.length === 0
                ? "bg-white/50 text-slate-400"
                : "bg-white hover:bg-slate-50"
                } ${selectedRows.length > 0 ? "px-3" : "w-8"}`}
              title="Export to Excel"
            >
              <IconDownload size={17} stroke={2.5} />
              {selectedRows.length > 0 && (
                <span className="font-bold text-xs ml-1">({selectedRows.length})</span>
              )}
            </button>

            {data && data.totalPages * limit > 10 && (
              <EntriesSelector
                value={limit}
                options={[
                  10,
                  ...(data.totalPages * limit > 10 ? [20] : []),
                  ...(data.totalPages * limit > 20 ? [30] : []),
                  ...(data.totalPages * limit > 50 ? [50] : []),
                  ...(data.totalPages * limit > 100 ? [100] : []),
                ]}
                onChange={(val) => {
                  setLimit(val);
                  setPageNo(1);
                }}
              />
            )}


            {/* Add + Bulk Upload buttons */}
            {canCreateClient && (
              <>
                <button
                  onClick={() => window.dispatchEvent(new CustomEvent("openAddMerchantModal"))}
                  className="flex items-center justify-center p-2 bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-xl transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 duration-150"
                  title="Add Merchant"
                >
                  <IconPlus size={17} stroke={2.5} />
                </button>
                <button
                  onClick={() => window.dispatchEvent(new CustomEvent("openMerchantBulkUploadModal"))}
                  className="flex items-center justify-center p-2 bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-xl transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 duration-150"
                  title="Bulk Upload"
                >
                  <IconUpload size={17} stroke={2.5} />
                </button>
              </>
            )}
          </div>
        </div>

        <div className="py-4">
          {data?.clients && data.clients.length > 0 ? (
            <GridView
              data={data?.clients}
              columns={5}
              className="grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
              renderItem={(client: any) => (
                <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                  <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />

                  {/* Header */}
                  <div className="flex items-start justify-between border-b border-[#D2D2D2]/70">
                    <div>
                      <p className="text-[11px] text-[#212121] uppercase tracking-wider">
                        {client.clientId} . {client.clientType}
                      </p>

                      <h3 className="text-[#000000] font-semibold text-lg mt-1 line-clamp-1">
                        {client.name}
                      </h3>
                    </div>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!canUpdateClient) {
                          toast.error("You do not have permission to update merchant status");
                          return;
                        }
                        setId(client?.id);
                        setStatus(client?.status);
                      }}
                      className={`px-3 py-1 rounded-full text-xs font-medium cursor-pointer capitalize ${client.status === "ACTIVE"
                        ? "bg-green-500/15 text-green-400"
                        : "bg-red-500/15 text-red-400"
                        }`}
                    >
                      <T>{client?.status === "ACTIVE" ? "Active" : "Inactive"}</T>
                    </button>
                  </div>

                  <div className="space-y-3">
                    {/* Role */}
                    <div className="flex items-center justify-between">
                      <span className="text-[#212121] text-sm"><T>Access</T>:</span>
                      <span className="text-[#212121] text-sm font-medium">
                        {client.access}
                      </span>
                    </div>

                    {/* Phone */}
                    <div className="flex items-center justify-between">
                      <span className="text-[#212121] text-sm"><T>Phone</T>:</span>
                      <span className="text-[#212121] text-sm font-medium">
                        {client.mobileNo}
                      </span>
                    </div>

                    {/* Email */}
                    <div className="flex items-center justify-between">
                      <span className="text-[#212121] text-sm"><T>Email</T>:</span>
                      <span
                        className="text-[#212121] text-sm font-medium truncate max-w-[160px]"
                        title={client.email}
                      >
                        {client.email}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <button
                      className="flex-1 h-10 rounded-lg bg-[#FBD037]/20  text-[#000000] text-sm font-medium "
                      onClick={() => {
                        window.dispatchEvent(
                          new CustomEvent("openMerchantModal", {
                            detail: {
                              id: client.id,
                            },
                          }),
                        );
                      }}
                    >
                      <T>View Profile</T>
                    </button>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        window.dispatchEvent(
                          new CustomEvent("openManagePickupLocationsModal", {
                            detail: {
                              id: client.id,
                              merchant: client,
                            },
                          }),
                        );
                      }}
                      className="h-10 w-10 flex items-center justify-center rounded-lg bg-[#FBD037]/20 text-[#000000]"
                    >
                      <IconMapPin />
                    </button>
                  </div>
                </div>
              )}
            />
          ) : (
            <NoDataFound />
          )}
          <div className="flex justify-center items-center pt-4">
            {data?.totalPages > 1 && (
              <Pagination
                currentPage={pageNo}
                totalPages={data.totalPages}
                fetchData={handlePaginationFetch}
              />
            )}
          </div>
        </div>
      </div>

      {/* {viewMerchantModal && selectedMerchantId && (
        <ViewMerchantModal
          id={selectedMerchantId}
          open={viewMerchantModal}
          onClose={() => {
            setViewMerchantModal(false);
            setSelectedMerchantId(null);
          }}
          refetchList={refetch}
        />
      )}

      <NewCommonModal
        title={"Add Merchant"}
        open={credential}
        closeButtonText={"Cancel"}
        onClose={credentialToggleModal}
        actionButtonText={isPending ? "Adding..." : "Add"}
        actionButtonOnClick={handleSubmit(handleCreate)}
        isPending={isPending}
      >
        <AddMerchantModal
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          setValue={setValue}
          control={control}
          getIds={getIds}
          watch={watch}
        />
      </NewCommonModal> */}


      <MessageModal
        open={activeDeleteModal}
        onClose={() => setActiveDeleteModal(false)}
        title={t("Confirmation Required")}
        subtitle={t("Are you sure you want to delete this Merchant?")}
        img={"/img/inactive.svg"}
        showFooter={true}
        closeButtonText={t("Cancel")}
        actionButtonText={t("Confirm")}
        actionButtonOnClick={deleteClient}
        isPending={isDeletePending}
        size="md"
      />

      {/* {openbluk && (
        <MerchantBulkUploadModals
          onClose={() => SetOpenBluk(false)}
          onResponseOpene={() => SetOpenResponse(true)}
          setStaffBulkResponse={setStaffBulkResponse} 
        />
      )}

      {openResponse && staffBulkResponse && (
        <MerchantBulkResponseModals
          data={staffBulkResponse}
          onClose={() => SetOpenResponse(false)}
        />
      )} */}
    </>
  );
}
